// src/Services/ConfigService.js
class ConfigService {
    static instance = null;
    static config = null;

    static getInstance() {
        if (!ConfigService.instance) {
            ConfigService.instance = new ConfigService();
        }
        return ConfigService.instance;
    }

    // Detect environment based on hostname
    detectEnvironment() {
        const hostname = window.location.hostname;
        
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'development';
        } else if (hostname.includes('staging') || hostname.includes('test')) {
            return 'staging';
        } else {
            return 'production';
        }
    }

    async loadConfig() {
        if (ConfigService.config) {
            return ConfigService.config;
        }

        const environment = this.detectEnvironment();
        const configFileName = `config.${environment}.json`;
        
        try {
            console.log(`Loading config for environment: ${environment}`);
            
            const response = await fetch(`/${configFileName}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
                cache: 'no-cache'
            });

            if (!response.ok) {
                throw new Error(`Config load failed: ${response.status} for ${configFileName}`);
            }

            ConfigService.config = await response.json();
            ConfigService.config.detectedEnvironment = environment; // Add detected env
            
            console.log('Configuration loaded:', ConfigService.config);
            return ConfigService.config;

        } catch (error) {
            console.error(`Failed to load ${configFileName}, trying fallback:`, error);
            
            // Try to load generic config.json as fallback
            try {
                const response = await fetch('/config.json', {
                    headers: { 'Content-Type': 'application/json' },
                    cache: 'no-cache'
                });
                
                if (response.ok) {
                    ConfigService.config = await response.json();
                    return ConfigService.config;
                }
            } catch (fallbackError) {
                console.error('Fallback config also failed:', fallbackError);
            }
            
            // Ultimate fallback - hardcoded config
            ConfigService.config = this.getDefaultConfig();
            return ConfigService.config;
        }
    }

    getDefaultConfig() {
        return {
            apiUrl: window.location.origin,
            imageUrl: window.location.origin + '/img',
            siteName: 'SuperCommerce',
            environment: 'development',
            features: {
                enablePayment: true,
                enableChat: false,
                maintenanceMode: false
            },
            defaults: {
                currency: 'ILS',
                language: 'he',
                itemsPerPage: 12
            }
        };
    }

    getConfig() {
        return ConfigService.config;
    }

    get(key, defaultValue = null) {
        if (!ConfigService.config) {
            console.warn('Config not loaded yet');
            return defaultValue;
        }
        
        // Support nested keys like 'features.enablePayment'
        const keys = key.split('.');
        let value = ConfigService.config;
        
        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            } else {
                return defaultValue;
            }
        }
        
        return value;
    }
}

export default ConfigService;